import React from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import {AprobacionAnyProvider} from './AprobacionAnyContext'
import {AprobacionAnyBody} from './components/AprobacionAnyBody'
import {AprobacionAnyHeader} from './components/AprobacionAnyHeader'

const breadCrumbs = [
  {
    title: 'Aprobación de documentos',
    path: '/seguimiento/aprobacion-any',
    isSeparator: false,
    isActive: false,
  },
]

export const AprobacionAny: React.FC = () => {
  return (
    <>
      <AprobacionAnyProvider>
        <BasicBreadcrumbs breadcrumbs={breadCrumbs} fallbackTitle='Aprobación de documentos' />
        <KTCard>
          <AprobacionAnyHeader />
          <KTCardBody>
            <AprobacionAnyBody />
          </KTCardBody>
        </KTCard>
      </AprobacionAnyProvider>
    </>
  )
}
